import React from "react";

const JobCardButton = ({ text, href, icon,onClick }) => {
  return (
    <a href={href} className="default-btn border-radius-5" onClick={onClick}>
      {text} <i className={icon}></i>
    </a>
  );
};

export default JobCardButton;